/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import SingleQuotes from './SingleQuotes';
import { toast } from 'react-toastify';
import { getAllQuote } from '../../../../apis';
import Loader from '../../../../components/Admin/Loader';
import { handleLimitSkipWithPage } from './../../../../utils/handleLimitSkipWIthPage';

interface ComponentProps {
  setCount: (v: number) => void;
  limit: number;
}

const Quotes = ({ limit, setCount }: ComponentProps) => {
  const { page } = useParams();
  const [isFetchingQuotes, setIsFetchingQuotes] = useState<boolean>(false);
  const [allQuote, setAllQuote] = useState<any[]>([]);

  const fetchQuotes = async () => {
    try {
      setIsFetchingQuotes(true);
      const { data } = await getAllQuote(
        'unread',
        limit,
        handleLimitSkipWithPage(limit, Number(page)).skip
      );
      setCount(data?.data?.count);
      setAllQuote(data?.data?.quotes);
      setIsFetchingQuotes(false);
    } catch (error: any) {
      setIsFetchingQuotes(false);
      console.log(error);
      toast.error(error.response.data.message || 'Something went wrong.');
    }
  };

  useEffect(() => {
    fetchQuotes();
  }, [page]);

  return (
    <>
      <Wrapper>
        {!!allQuote?.length && (
          <>
            {allQuote?.map((item: any) => (
              <SingleQuotes
                allQuotes={allQuote}
                setAllQuotes={setAllQuote}
                key={item?._id}
                data={item}
              />
            ))}
          </>
        )}
      </Wrapper>
      {!!isFetchingQuotes && <Loader />}
    </>
  );
};

export default Quotes;

const Wrapper = styled.div`
  margin-top: 15px;
`;
